import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component
export class TrackType extends Vue {
  @Prop({ required: true }) type;

  get bc() {
    if (this.type.includes("Audio")||this.type.includes("audio")) {
      return "#7878f080";
    } else if (this.type == "video"||this.type == "Video") {
      return "#64c99680";
    } else if (this.type == "mix"||this.type == "Mix") {
      return "#ff707080";
    }
  }
  render(h) {
    return <span
      style={`
      margin: 0px auto;
      padding: 3px 8px;
      border-radius: 15px;
      text-transform: capitalize;
      background: ${this.bc}
      `}
      title={this.type}
    >{this.type}</span>;
  }
}